import React, { useState, useRef } from "react";
import Formsy from "formsy-react";
import { observer } from "mobx-react";

import { createStyles, makeStyles } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";

import DateTimeInput from "../../components/forms/inputs/DateTimeInput";
import SubmitButtonInput from "../../components/forms/inputs/SubmitButtonInput";
import TextfieldInput from "../../components/forms/inputs/TextfieldInput";
import moment from "moment";

const useStyles = makeStyles(theme =>
  createStyles({
    formContainer: {},
    formItem: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(1)
    }
  })
);

function EditSensorForm(
  { _notifications, sensor, room },
  { _validationErrors }
) {
  const [validForm, setValidForm] = useState(false);
  const [loading, setLoading] = useState(false);

  const form = useRef(null);

  const submitForm = model => {
    setLoading(true);

    model.baseline = Number(model.baseline);
    model.slope = Number(model.slope);

    const notes = model.notes;
    delete model["notes"];

    return (
      sensor &&
      sensor
        .partialUpdate({
          notes: notes,
          data_ready_timestamp: model.data_ready_timestamp,
          data_unready_timestamp: model.data_unready_timestamp,
          calibration: {
            ...sensor.calibration,
            baseline: model.baseline,
            slope: model.slope,
            start_timestamp: model.start_timestamp.unix()
          }
        })
        .then(() => {
          Promise.all([sensor.pullMeasurements(), room.pullReadings()]).then(
            () => {
              setLoading(false);
              form.current.reset({ ...model, notes: notes });
            }
          );
        })
    );
  };

  const classes = useStyles();

  return (
    <Formsy
      ref={form}
      onValidSubmit={submitForm}
      onValid={() => setValidForm(true)}
      onInvalid={() => setValidForm(false)}
    >
      <Grid
        className={classes.formContainer}
        container
        alignContent="flex-start"
        alignItems="center"
      >
        <Grid className={classes.formItem} item sm={6}>
          <TextfieldInput
            value={((sensor || {}).calibration || {}).slope}
            name="slope"
            label="Slope"
            required
          />
        </Grid>
        <Grid className={classes.formItem} item sm={6}>
          <TextfieldInput
            value={((sensor || {}).calibration || {}).baseline}
            name="baseline"
            label="Baseline"
            required
          />
        </Grid>
        <Grid className={classes.formItem} item sm={4}>
          <DateTimeInput
            value={
              ((sensor || {}).calibration || {}).start_timestamp
                ? moment.unix(
                    ((sensor || {}).calibration || {}).start_timestamp
                  )
                : null
            }
            name="start_timestamp"
            label="Start Timestamp"
            elementProps={{
              format: "MM/DD/YYYY hh:mm:ss"
            }}
            required
          />
        </Grid>
        <Grid className={classes.formItem} item sm={4}>
          <DateTimeInput
            value={
              (sensor || {}).data_ready_timestamp
                ? (sensor || {}).data_ready_timestamp
                : null
            }
            name="data_ready_timestamp"
            label="Data Ready Timestamp"
            elementProps={{
              format: "MM/DD/YYYY hh:mm:ss"
            }}
          />
        </Grid>
        <Grid className={classes.formItem} item sm={4}>
          <DateTimeInput
            value={
              (sensor || {}).data_unready_timestamp
                ? (sensor || {}).data_unready_timestamp
                : null
            }
            name="data_unready_timestamp"
            label="Data Unready Timestamp"
            elementProps={{
              format: "MM/DD/YYYY hh:mm:ss"
            }}
          />
        </Grid>
        <Grid className={classes.formItem} item sm={12}>
          <TextfieldInput
            value={(sensor || {}).notes || ""}
            name="notes"
            label="Notes"
            elementProps={{
              multiline: true
            }}
          />
        </Grid>
        <Grid className={classes.formItem} item sm={12}>
          <SubmitButtonInput
            name="submit"
            contents="Save"
            validForm={validForm}
            loading={loading}
            elementProps={{
              color: "primary"
            }}
          />
        </Grid>
      </Grid>
    </Formsy>
  );
}

export default observer(EditSensorForm);
